<div class="wheelchair">
    <!-----------Overview-------->
    <app-shared-overview
        [title]="registers?.title"
        [breadcrumb]="registers?.module"
        [image]="overviewImage"
    ></app-shared-overview>
    <div class="container">
        <div class="row page-row justify-content-center">
            <div class="col-12">
                <div class="col-12">
                    <app-shared-partner
                        [formatType]="'BNTENNISTOOL02'"
                        [position]="'DEPARTMENT_HEADER'"
                        [direction]="'horizontal'"
                        [depto]="'DEPARTMENT_TYPE_WHEELCHAIR'"
                    ></app-shared-partner>
                </div>
            </div>
            <!-----------Sidebar-------->
            <div class="col-12 col-lg-3">
                <app-shared-sidebar [departmentType]="departmentType" [menu]="registers?.menu"></app-shared-sidebar>
                <div class="col-12">
                    <div class="col-12">
                        <app-shared-partner
                            [formatType]="'BNTENNISTOOL04'"
                            [position]="'DEPARTMENT_SIDEBAR'"
                            [chunks]="2"
                            [direction]="'vertical'"
                            [depto]="'DEPARTMENT_TYPE_WHEELCHAIR'"
                        ></app-shared-partner>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 flex-grow-1">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
